import { makeStyles } from "@material-ui/core";

const useTabPanelStyles = makeStyles(
  (theme) => ({
    tab: {
      textTransform: "none",
      minWidth: 40,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),

      "&$selected": {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightRegular,
      },
      "&:focus": {
        color: theme.palette.secondary.main,
      },
    },

    root: {
      width: "100%",
      overflowX: "hidden",
      overflowY: "auto",
    },

    tabs: {
      borderBottom: "1px solid #e8e8e8",
    },

    tabsPanel: {
      width: "100%",
      height: "calc(100vh - 150px)",
      overflowX: "hidden",
      overflowY: "auto",
    },

    subButton: {
      textTransform: "none",
      fontSize: 10,
      padding: 2,
      margin: 2,
      width: 35,
    },
  }),
  { name: "common-tab-panel-styles", flip: null }
);

export default useTabPanelStyles;
